<template>
    <div class="form-group position-relative">
        <label v-if="title && title.trim().length > 0">
            {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <div class="input-group date" :id="idPicker" data-target-input="nearest">
            <input type="text" class="form-control datetimepicker-input" :data-target="'#' + idPicker"
                :disabled="isReadOnly" :placeholder="placeholder" v-model="displayValue" @focus="onFocus" @blur="onBlur"
                :class="{ 'is-invalid': error }" />
            <div class="input-group-append" :data-target="'#' + idPicker" data-toggle="datetimepicker">
                <div class="input-group-text"><i class="fa fa-calendar"></i></div>
            </div>
        </div>
        <!-- Note hiển thị như tin nhắn -->
        <div v-if="showFormatNote" class="note-tooltip">
            Định dạng: DD/MM/YYYY
        </div>
        <div class="text-danger text-right" v-if="error">
            {{ error }}
        </div>
    </div>
</template>


<script>
import { ref, toRefs, watch } from "vue";
import moment from "moment";

export default {
    name: "TheDatePicker",
    props: {
        title: String,
        placeholder: String,
        initialValue: String,
        error: String,
        minDate: String,
        maxDate: String,
        pickerId: { // ID động cho datetimepicker
            type: String,
            required: false,
        },
        isReadOnly: Boolean,
        isRequire: Boolean,
    },
    data() {
        return {
            idPicker: this.pickerId ? this.pickerId : '_' + Math.random().toString(36).substr(2, 9),
        }
    },
    setup(props, { emit }) {
        const displayValue = ref(props.initialValue || "");
        const showFormatNote = ref(false);

        watch(displayValue, (newVal) => {
            emit("update:modelValue", newVal);
            emit("onChangeDate", newVal);
        });

        // Hàm xử lý focus
        const onFocus = () => {
            showFormatNote.value = true;
        };

        // Hàm xử lý blur
        const onBlur = () => {
            // Kiểm tra nếu giá trị không hợp lệ thì tắt note
            if (!moment(displayValue.value, "DD/MM/YYYY", true).isValid()) {
                displayValue.value = ""; // Trả về rỗng nếu không hợp lệ
            }
            showFormatNote.value = false;
        };

        return {
            displayValue,
            showFormatNote,
            onFocus,
            onBlur,
        };
    },
    mounted() {
        const self = this;
        const pickerSelector = `#${this.idPicker}`;

        $(pickerSelector).datetimepicker({
            format: 'DD/MM/YYYY',
            locale: 'vi',
        });
        $(pickerSelector).on("change.datetimepicker", function (e) {
            if (e.date) {
                const selectedDate = e.date.format("DD/MM/YYYY");
                self.displayValue = selectedDate;
            } else {
                const isValid = moment(self.displayValue, "DD/MM/YYYY", true).isValid();
                if (!isValid) {
                    self.displayValue = ""; // Trả về rỗng nếu giá trị không hợp lệ
                }
            }
        });
        $(pickerSelector).on("show.datetimepicker", function (e) {
            self.showFormatNote = false;
        });

    },
};
</script>
<style>
.note-tooltip {
    position: absolute;
    top: 100%;
    /* Hiển thị ngay dưới input */
    left: 0;
    margin-top: 5px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 12px;
    color: #495057;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}
</style>
